import CalendarMonth from "@mui/icons-material/CalendarMonth";
import { ScheduleButton } from "./schedule-button";

import type { ScheduleButtonProps } from "./schedule-button";
import type { FC } from "react";

export const ScheduleSpecificButton: FC<Omit<ScheduleButtonProps, "icon" | "title">> = (props) => (
  <ScheduleButton icon={<CalendarMonth />} title="Schedule send" {...props} />
);
